<span #deleteIconTooltipContainer data-bs-toggle="tooltip" data-bs-html="true" [attr.data-bs-title]="toolTipHtmlContent"
  data-bs-sanitize="true" data-bs-delay="200" data-bs-placement="auto">
  <i class="bi bi-trash c-pointer" (click)="deleteClicked()"></i>
</span>
